import getSessionId from './getSessionId'

export default function skyEyesErrorLog(msg: string, error: any = {}) {
    try {
        const img = document.createElement('img');
        img.src = 'https://fedservice.enbrands.com/log/feed' +
            `?id=jd_cheaper_pack_errors&` +
            `category=${encodeURIComponent('$error')}&` +
            `label=${encodeURIComponent(msg)}&` +
            `action=${encodeURIComponent(getSessionId())}&` +
            `v1=&` +
            `v2=&` +
            `value=1&` +
            `openId=&` +
            `extparams=${encodeURIComponent(
                JSON.stringify(error.stack ? {
                    message: error.message,
                    stack: error.stack
                } : error)
            )}`;
    } catch (e) {
        // console
        // 上报错误
    }
}

(window as any).skyEyesErrorLog = skyEyesErrorLog;
